// Per-employee work nature (mirror of backend enums/workNature.ts). Only OFFICE
// staff compete in the reward contest.
const workNature = {
  OFFICE: "OFFICE",
  HYBRID: "HYBRID",
  FULLY_REMOTE: "FULLY_REMOTE",
  OFFICE_ASSISTANT: "OFFICE_ASSISTANT",
};

export default workNature;

// Human labels for selects / chips.
export const WORK_NATURE_LABELS = {
  OFFICE: "Office",
  HYBRID: "Hybrid",
  FULLY_REMOTE: "Fully remote",
  OFFICE_ASSISTANT: "Office assistant",
};

export const WORK_NATURE_OPTIONS = [
  { value: "OFFICE", label: "Office" },
  { value: "HYBRID", label: "Hybrid" },
  { value: "FULLY_REMOTE", label: "Fully remote" },
  { value: "OFFICE_ASSISTANT", label: "Office assistant" },
];
